import ApplicationStatus from 'platform/forms/save-in-progress/ApplicationStatus';
import Wizard from '../../static-pages/wizard';
import pages from './pages';

export default {
  Wizard,
  ApplicationStatus,
  pages,
};
